import { Marker, Popup, Polyline, useMap } from "react-leaflet";
import heightRestrictionResource from "../../../assets/heightRestrictionIcon.png"
import * as L from "leaflet";
import { GeoJsonFeature } from "../../../services/OgcService/models/GeoJsonFeature";
import { HeightRestrictionProperties } from "../../../services/OgcService/models/HeightRestrictionFeatureCollection";

export interface IHeightRestrictionMarkerProps{
    heightRestriction: GeoJsonFeature<HeightRestrictionProperties>
}

function GetMedianCoordinate(coordinates: number[][]) {
    const median = Math.round(coordinates.length / 2);
    return coordinates[median];
} 

const heightRestrictionIcon = (height: number) => L.divIcon({
    html: '<img src=\'' + heightRestrictionResource + '\'/><p class="heightRestrictionParagraph">' + (Math.round(height * 100) / 100).toFixed(1) + '</p>',
    iconSize: [0, 0],
    iconAnchor: [17, 40],
})

export function HeightRestrictionMarker(heightRestrictionMarkerProps: IHeightRestrictionMarkerProps) {
    const coordinate = GetMedianCoordinate(heightRestrictionMarkerProps.heightRestriction.geometry.coordinates)
    const props = heightRestrictionMarkerProps?.heightRestriction?.properties;

    return (
        <>
        {
            props && 
            <Marker alt={props.SKILTA_HOYDE.toString()} key={heightRestrictionMarkerProps.heightRestriction.id} icon={heightRestrictionIcon(props.SKILTA_HOYDE)} position={[coordinate[1], coordinate[0]]}>
                <Popup>
                    <div className="heightRestrictionPopupContent">
                        <p><strong>Navn: </strong>{props.NAVN}</p>
                        <p><strong>NvdbId-versjon: </strong>{props.VEGOBJEKT}</p>
                        <p><strong>Sist oppdatert fra NVDB: </strong>{props.SIST_OPPDATERT_FRA_NVDB.toLocaleString()}</p>
                        <p><strong>Skilta høyde: </strong>{props.SKILTA_HOYDE}</p>
                        <p><strong>VeglenkesekvensId: </strong>{props.VEGLENKESEKVENSID}</p>
                        <p><strong>Startpos: </strong>{props.STARTPOSISJON}</p>
                        <p><strong>Sluttpos: </strong>{props.SLUTTPOSISJON}</p>
                        <p><strong>Status oppdatert: </strong>{props.STATUS_OPPDATERT}</p>
                        <p><strong>Type hinder: </strong>{props.TYPE_HINDER}</p>
                        <p><a target={"_blank"} href={"https://vegkart.atlas.vegvesen.no/#kartlag:geodata/valgt:" + props.VEGOBJEKT + ":591"}>Se i vegkart</a></p>
                    </div>
                    </Popup>
            </Marker>

        }
        </>
    )
}